import { render } from "./PatientDataTable.vue?vue&type=template&id=dd804aea"
import script from "./PatientDataTable.vue?vue&type=script&lang=js"
export * from "./PatientDataTable.vue?vue&type=script&lang=js"

import "./PatientDataTable.vue?vue&type=style&index=0&id=dd804aea&lang=scss"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__